module.exports = __webpack_public_path__ + "img/hummusteller.2e2e4465.png";